class Breadcrumb {

    constructor() {

        const togglerElement = document.querySelector('.breadcrumb__truncated-toggler');
        const wrapperElement = document.querySelector('.breadcrumb__truncated');
        const activeClassName = 'breadcrumb__truncated-toggler--active';

        if (togglerElement && wrapperElement) {
            togglerElement.addEventListener('click', (e) => {
                togglerElement.classList.toggle(activeClassName);
            })

            document.addEventListener('click', (e) => {
                const isActive = togglerElement.classList.contains(activeClassName);
                const isClickInside = wrapperElement.contains(e.target)

                if (!isClickInside && isActive) {
                    togglerElement.classList.remove(activeClassName);
                }
            })
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new Breadcrumb();
});